import React from "react";

export function DeleteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_373_85359)">
        <rect width="24" height="24" rx="12" fill="#2E2E38" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4199 9.50747C17.6919 9.55529 17.8736 9.81453 17.8258 10.0865L16.4958 17.6507C16.4958 17.6507 16.4958 17.6507 16.4958 17.6507C16.3417 18.5273 15.5802 19.1666 14.6902 19.1666H9.30983C8.41978 19.1666 7.65832 18.5273 7.50419 17.6507L6.17422 10.0865C6.1264 9.81453 6.30811 9.55529 6.58008 9.50747C6.85205 9.45965 7.11129 9.64136 7.15911 9.91333L8.48909 17.4775C8.55915 17.876 8.90528 18.1666 9.30983 18.1666H14.6902C15.0947 18.1666 15.4408 17.876 15.5109 17.4776L16.8409 9.91333C16.8887 9.64136 17.1479 9.45965 17.4199 9.50747Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0833 5.83325C10.6231 5.83325 10.25 6.20635 10.25 6.66659V7.49992H13.75V6.66659C13.75 6.20634 13.3769 5.83325 12.9167 5.83325H11.0833ZM9.25 7.49992V6.66659C9.25 5.65406 10.0708 4.83325 11.0833 4.83325H12.9167C13.9292 4.83325 14.75 5.65407 14.75 6.66659V7.49992H18C18.2761 7.49992 18.5 7.72378 18.5 7.99992C18.5 8.27606 18.2761 8.49992 18 8.49992H6C5.72386 8.49992 5.5 8.27606 5.5 7.99992C5.5 7.72378 5.72386 7.49992 6 7.49992H9.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_373_85359">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
